import { render, staticRenderFns } from "./JobDescriptionModal.vue?vue&type=template&id=97794f04&scoped=true&"
import script from "./JobDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./JobDescriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./JobDescriptionModal.vue?vue&type=style&index=0&id=97794f04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97794f04",
  null
  
)

export default component.exports